import type { DropdownFilterCallback } from '../components/Dropdown/Dropdown';
import type { ContentTypeDefinition } from '../lib/flotiq-client/types/api-response';

import { createContext } from 'react';

interface PropertyModalCtdsContextProps {
  ctds?: { label: string; value: string }[];
  getValidationType?: (value: string) => Promise<ContentTypeDefinition | null>;
  ctdsAreLoading?: boolean;
  filterCtds?: DropdownFilterCallback;
}

export const PropertyModalCtdsContext =
  createContext<PropertyModalCtdsContextProps>({});

export default PropertyModalCtdsContext;
